<!-- =========================================================================================
  File Name: QnAList.vue
  Description: QnA List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
button.vs-component.vs-button.ml-3.setting-btn.vs-button-primary.vs-button-border {
  padding: 6px !important;
}
.setting-btn span img {
  height: 20px;
  width: 20px;
}
.file-up-section {
  text-align: center;
  border: 2px dashed #c8c8c8;
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}
.file-up-section p {
  color: #4c8af6;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}
.header-custome {
  margin-bottom: 15px;
  padding-left: 2px;
}
.header-custome {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.knowlg-base-wrap-sec a {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 12px;
}
.knowlg-base-wrap-sec a span{margin-right: 10px; line-height: 0;}
.single-row{width: 100%; display: flex; justify-content: space-between;align-items: center;}
.mapping-add-button{text-align: right;}
.angeda-builder-left{display: flex; justify-content: flex-start; align-items: center;}
.export-import-buttons-right{text-align: right;}
.angeda-builder-left .v-select {min-width: 218px;}
.mapping-popup-wrapper.con-vs-popup .vs-popup{width: 1000px !important;}
.mapping-drop-area{width: 100%; height: 300px; border: 1px solid #cdcdcd; border-radius: 10px;padding: 15px;display: flex; justify-content: flex-start; align-items: flex-start; flex-wrap: wrap;position: relative;overflow: hidden;}
.mapping-drop-area-bottom{padding: 8px 10px; background: #fff; position: absolute; bottom: 0; left: 0; width: 100%;display: flex; justify-content: space-between; align-items: center;}
.mapping-drop-area p{text-align: center; font-size: 16px;}
.attendee-mapping{width: 100%; height: 349px; border: 1px solid #cdcdcd; border-radius: 10px; display: flex;justify-content: flex-start; align-items: flex-start; flex-wrap: wrap;position: relative;overflow: hidden;}
.attendee-mapping p{text-align: center; font-size: 16px;}
.border-right-1{border-right: 1px solid #cdcdcd;}
.map-button-area{text-align: right;}
.attendee-map-head {display: flex;justify-content: space-between;align-items: center;}
.map-switch {display: flex; justify-content: flex-end; align-items: center;}
.search-section{position: relative;}
.session-search-drop {width: 100%; position: absolute; background: #fff; padding: 15px; z-index: 999; box-shadow: 0 0 7px rgba(0,0,0,0.3); border-radius: 5px;}
.drop-area-top {display: flex;justify-content: space-between; align-items: center; padding-bottom: 10px; margin-bottom: 15px; border-bottom: 1px solid #dfdfdf;}
.single-list-session {display: flex; justify-content: flex-start; align-items: flex-start;}
.single-session-details p {font-size: 12px; font-weight: 400; color: #999;}
.session-listing {height: 200px; overflow-y: auto;}
.selected-session {display: inline-flex !important; justify-content: flex-start; align-items: flex-start; background: #dfdfdf; padding: 10px; border-radius: 5px; position: relative;margin-right: 10px; margin-bottom: 10px;}
.selected-session-details h5 {font-size: 14px;font-weight: 400; color: #000;}
.selected-session-details p {font-size: 9px;}
.close-ico {position: absolute; top: 2px; right: 8px;}
.removal-allow {display: flex; justify-content: flex-start; align-items: center;}
.selected-action .delete-button{color: #f00; font-weight: 600; font-size: 13px;}
.selected-action .select-all-button{color: #000; font-size: 13px; font-weight: 600;}
.selected-action .select-all-button span{width: 6px; height: 11px; border: solid #000; border-width: 0 2px 2px 0; transform: rotate(45deg); display: inline-block; margin-right: 4px;}
.selected-session-wrap {height: 100%; overflow-y: auto;}
.attendee-search-section {position: absolute; background: #fff; width: 100%; box-shadow: 0 0 7px rgba(0,0,0,0.3); padding: 15px; border-radius: 5px;z-index: 9999;}
.attendee-search-top{display: flex; justify-content: space-between; align-items: center; padding-bottom: 10px; margin-bottom: 15px; border-bottom: 1px solid #dfdfdf;}
.attendee-list ul li {margin-bottom: 12px;}
.attendee-list {height: 154px; overflow-y: auto;}
.mapped-attendee-wrapper {height: 100%; overflow-y: auto; padding: 13px;}
.mapped-attendee {background: #dfdfdd; margin-right: 11px; padding: 10px 28px 10px 10px; position: relative; border-radius: 4px; margin-bottom: 10px; float: left;position: relative;}
a.close-ico2 {position: absolute; top: 50%; right: 9px; transform: translateY(-50%); color: #333; font-weight: 600; display: inline-block;}
</style>
<template>
  <div id="page-user-list">
    <div class="header-custome">
      <h3>Agenda Builder</h3>
      <div class="knowlg-base-wrap-sec hidden">
        <a href="/pages/knowledge-base/category-sessions/question-2"><span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg></span> Need help with this section?</a>
      </div>
    </div>    
    

    <div class="vx-card p-6">
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full mb-5">
         <div class="angeda-builder-left">
            <vs-input
            class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
            v-model="searchQuery"
            @input="updateSearchQuery"
            placeholder="Session title/tracn name"
            />

            <v-select class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" label="Name" v-model="Session" :options="sessionList" />
            <a href="">
              <feather-icon
                class="sm:mr-4"
                icon="RefreshCwIcon"
                @click.stop="showSidebar"
              />
            </a>
            <vs-button class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" color="rgb(76, 139, 246)" type="filled" @click="$router.push('/event/sessions')">Add new Session</vs-button>
          </div>
        </div>
        <div class="vx-col md:w-1/1 w-full">
          <vs-tabs  alignment="left" v-model="selectedTab" >
            <vs-tab label="Mapping by Session" @click="getListData('Session')"></vs-tab>
            <vs-tab label="Mapping by User" @click="getListData('User')"></vs-tab>
            <vs-tab label="Mapping by Group" @click="getListData('Group')"></vs-tab>
          </vs-tabs>
        </div>
        <div class="vx-col md:w-1/2 w-full">
        </div>
        <div class="vx-col md:w-1/2 w-full mb-5">
          <div class="mapping-add-button">         
            
          </div>
          <vs-popup class="holamundo mapping-popup-wrapper" title="Add/Edit Mappings" :active.sync="popupActive">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full border-right-1">
                <h4 class="mb-4">Session</h4>
                <div class="vx-row">
                  <div class="vx-col md:w-1/2 w-full">
                    <datepicker placeholder="Select Date" :clear-button="true" v-model="StartDate"></datepicker>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <v-select placeholder="Select Track" v-model="Track" label="TrackName" :options="trackList" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  </div>
                </div>
                <div class="search-section mt-3">
                   <vs-input class="inputx w-full" @click.stop="show" placeholder="Search Session" v-model="sessionName" @keyup="searchSession" />
                   <div class="callout session-search-drop" v-if="showInside" >
                      <div class="drop-area-top">
                        <vs-checkbox @change="selectAllSessions" v-model="SelectAllSessions">Select all</vs-checkbox>
                        <div class="drop-area-top-right">
                          <vs-button color="primary" type="filled" class="mr-3" @click="hide">Add</vs-button>
                          <a href="javascript:void(0)" @click="hide">x</a>
                        </div>
                      </div>
                      <div class="session-listing">
                        <div class="single-list-session mb-5" v-for="session in session_search_list">
                          <vs-checkbox v-model="SelectedSessions" :vs-value="session"></vs-checkbox>
                          <div class="single-session-details">
                            <h5>{{session.Name}}</h5>
                            <p>
                              {{SetTimeByZoneinList(new Date(session.StartDate.seconds * 1000).toUTCString())}} ,
                              {{SetTimeByZoneinList(new Date(session.EndDate.seconds * 1000).toUTCString())}} 
                            </p>
                          </div>
                        </div>                        
                      </div>
                   </div>
                </div>
                <div class="mapping-drop-area mt-3">
                  <div class="selected-session-wrap">
                    <div class="selected-session" v-for="session in SelectedSessions">
                      <vs-checkbox v-model="SelectedSessionsOuter" :vs-value="session"></vs-checkbox>
                      <div class="selected-session-details">
                        <h5>{{session.Name}}</h5>
                        <p>
                          {{SetTimeByZoneinList(new Date(session.StartDate.seconds * 1000).toUTCString())}} ,
                          {{SetTimeByZoneinList(new Date(session.EndDate.seconds * 1000).toUTCString())}} 
                        </p>
                      </div>
                      <div class="close-ico" @click="removeSession(session)">x</div>
                    </div>                    
                  </div>
                  <div class="mapping-drop-area-bottom">
                    <!-- <div class="removal-allow">
                      <label class="mr-3">Allow Removal</label>
                      <vs-switch v-model="switch5" />
                    </div> -->
                    <div class="selected-action">
                      <a href="javascript:void(0)" @click="deleteAllSelectedSessions" class="mr-5 delete-button">x Delete Selected</a>
                      <a href="javascript:void(0)" @click="selectAllSelectedSessions" class="select-all-button"><span></span> Select All</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="attendee-map-head mb-4">
                  <h4 >Attendees</h4>
                  <div class="map-switch">
                    <label class="mr-3">Select all</label>
                    <vs-switch @change="selectAllAttendees" v-model="SelectAllAttendees" />
                  </div>
                </div>
                <div class="search-section mt-3">
                   <vs-input class="inputx w-full" @click.stop="show2" placeholder="Search Attendees" @keyup="searchAttendee" v-model="attendeeName" />
                   <div class="callout attendee-search-section" v-if="showInside2" >
                    <div class="attendee-search-top">
                      <vs-checkbox @change="selectAllAttendees" v-model="SelectAllAttendees">Select all</vs-checkbox>
                      <div class="drop-area-top-right">
                        <vs-button color="primary" type="filled" class="mr-3" @click="hide">Add</vs-button>
                        <a href="javascript:void(0)" @click="hide">x</a>
                      </div>
                    </div>
                    <div class="attendee-list">
                      <ul>
                        <li v-for="attendee in attendee_search_list">
                          <vs-checkbox v-model="SelectedAttendees" :vs-value="attendee">{{attendee.FirstName}} {{attendee.LastName}}
                          </vs-checkbox>
                        </li>                        
                      </ul>
                    </div>
                   </div>
                </div>
                <div class="attendee-mapping mt-3">
                  <div class="mapped-attendee-wrapper">
                    <div class="mapped-attendee" v-for="attendee in SelectedAttendees">
                      <vs-checkbox v-model="SelectedAttendeesOuter" :vs-value="attendee">{{attendee.FirstName}} {{attendee.LastName}}</vs-checkbox> 
                      <!--<a href="javascript:void(0)" class="close-ico2" @click="removeAttendee(attendee)">x</a>-->
                    </div>                    
                  </div>
                  <div class="mapping-drop-area-bottom">
                    <!-- <div class="removal-allow">
                      <label class="mr-3">Allow Removal</label>
                      <vs-switch v-model="switch5" />
                    </div> -->
                    <div class="selected-action">
                      <a href="javascript:void(0)" class="mr-5 delete-button" @click="deleteAllSelectedAttendees">x Delete Selected</a>
                      <a href="javascript:void(0)" class="select-all-button" @click="selectAllSelectedAttendees"><span></span> Select All</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="map-button-area mt-5">
              <vs-button color="primary" type="flat" class="mr-3">Reset</vs-button>
              <vs-button color="rgb(76, 139, 246)" type="filled" @click="mapSessionAttendee">Map</vs-button>
            </div>
          </vs-popup>
        </div>

      </div>
      <div class="vx-row">
        <!-- ITEMS PER PAGE -->
        <div class="vx-col md:w-1/2 w-full">
          <!--<vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ sessionsData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : sessionsData.length }} of {{ sessionsData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>-->
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <!--<vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>-->
         
        </div>
        <div class="vx-col md:w-1/2 w-full">

          

          <div class="export-import-buttons-right">
            <!-- <vs-button type="gradient border" class="mr-3" @click="addMapping" color="primary">Add/Edit Mappings</vs-button> -->
            <!--<vs-button type="gradient" class="mr-3">Map Users</vs-button>
            <vs-button type="border" text-color="#7367F0" class="mr-3">Delete</vs-button>
            <vs-button type="border" text-color="#7367F0" class="mr-3">Export</vs-button>
            <vs-button type="border" text-color="#7367F0">Import</vs-button>-->
          </div>
        </div>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="attendeesData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import Datepicker from 'vuejs-datepicker';
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import moment from 'moment-timezone'

// Store Module
import moduleSessionManagement from "@/store/session-management/moduleSessionManagement.js";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import moduleTrackManagement from "@/store/track-management/moduleTrackManagement.js";
import moduleAgendaManagement from "@/store/agenda-management/moduleAgendaManagement.js";
import bu from "@/store/bulkupload/BulkUpload.js";
import ls from "@/common/localStorage";

// Cell Renderer
import CellRendererEditUser from "./cell-renderer/CellRendererEditUser.vue";
import CellRendererChangeStatus from "./cell-renderer/CellRendererChangeStatus.vue";

let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id")
let Session_EventStartDate = ls.getSessionValueByKey("Session_EventStartDate")
let Session_EventEndDate = ls.getSessionValueByKey("Session_EventEndDate")
let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ")

export default {
  components: {
    AgGridVue,
    vSelect,
    Datepicker,
    // Cell Renderer
    CellRendererEditUser,
    CellRendererChangeStatus
  },
  data() {
    return {
      StartDate: null,
      switch1:false,
      popupActive: false,
      selectedTab:1,
      settingsData: { ShowInAttendee: false },      
      Session: {
        Name: 'Select Session',
        SessionId: null
      },
      QnAId: null,
      AutoPublishApprovedQuestion: false,
      Attendee: null,
      sessionValue: {
        Answer: '',        
        Approved: false,
        IsAnonymous: false,
        IsPublished: false,
        Question: null
      },
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" }
      ],

      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" }
      ],

      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" }
      ],

      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" }
      ],
      showInside: false,
      showInside2: false,
      searchQuery: "",
      popupActive: false,
      popupActive2: false,
      popupActive3: false,
      switch5: null,
      value1: null,
      checkBox33: null,
      checkBox32: null,
      checkBox31: null,
      checkBox30: null,
      checkBox29: null,
      checkBox28: null,
      checkBox7: null,
      sessionList: [],
      attendeeList: [],
      SelectedSessions: [],
      SelectedAttendees: [],
      SelectedSessionsOuter: [],
      SelectedAttendeesOuter: [],
      SelectAllSessions: null,
      SelectAllAttendees: null,
      sessionName: null,
      attendeeName: null,
      session_search_list: [],
      attendee_search_list: [],
      unmap_attendees: [],
      trackList: [],
      Track: null,
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: "",
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          width: 50,
          //pinned: "left"
        },
        {
          headerName: "First Name",
          field: "FirstName",
          filter: true,
          width: 200,
          //pinned: "left"
        },
        {
          headerName: "Last Name",
          field: "LastName",
          filter: true,
          width: 200,
          //pinned: "left"
        },
        {
          headerName: "Email",
          field: "Email",
          filter: true,
          width: 200,
          //pinned: "left"
        },  
        {
          headerName: "Excluded Sessions",
          field: "ExcludedSessions",  
          cellRenderer: (data) => {
            return data.value ? data.value.length : 0
          },               
          filter: true,
          width: 100,
        },
        {
          headerName: "Included Sessions",
          field: "IncludedSessions",  
          cellRenderer: (data) => {
            return data.value ? data.value.length : 0
          },               
          filter: true,
          width: 100,
        },      
        {
          headerName: "Groups",
          field: "Groups",
          cellRenderer: (data) => {
            return data.value ? data.value.length : 0
          },
          filter: true,
          width: 150,
        },
        //{
        //  headerName: "Allow Removal",
        //  field: "AllowRemoval",
        //  filter: true
        //},
        /*{
          headerName: "Actions",
          field: "transactions",
          width: 150,
          cellRendererFramework: "CellRendererEditUser",
          cellRendererParams: (params) => {
            return { attendee: params.data };
          },          
        },*/
        
      ],

      // Cell Renderer Components
      components: {
        CellRendererEditUser,
        CellRendererChangeStatus
      }
    };
  },
  watch: {
    Track(val){
      this.searchSession()
    },
    StartDate(val){
      this.searchSession()
    }
  },
  computed: {    
    attendeesData() {
      return this.$store.state.attendeeManagement.attendeesmapping;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    }
  },
  events: {
    closeEvent: function () {
      console.log('close event called')
      this.hide()
    }
  },
  methods: {
    searchAttendee() {
      let attendeeName = this.attendeeName.trim().toLowerCase();
      if (attendeeName) {
        this.attendee_search_list = this.attendee_list.filter((row) => {
          if (
            String(row.FirstName).toLowerCase().includes(attendeeName) ||
            String(row.LastName).toLowerCase().includes(attendeeName) ||
            String(row.Email).toLowerCase().includes(attendeeName)
          ) {
            return true;
          } else {
            return false;
          }
        });
      } else {
        this.attendee_search_list = this.attendee_list;
      }
    },
    removeSession(session){
      let id = session.SessionId
      let index = this.SelectedSessions
        .map((x) => {
          return x.SessionId;
        })
        .indexOf(id);
      this.SelectedSessions.splice(index, 1);
    },
    removeAttendee(attendee){
      let id = attendee.AttendeeId
      let index = this.SelectedAttendees
        .map((x) => {
          return x.AttendeeId;
        })
        .indexOf(id);
      this.SelectedAttendees.splice(index, 1);
      this.unmap_attendees = [attendee]
    },
    searchSession() {
      this.session_search_list = this.sessionList; 
      if(this.StartDate){
        let StartDate = this.StartDate
        this.session_search_list = this.session_search_list.filter((row) => {
          if (
            new Date(row.StartDate.seconds * 1000) >= new Date(StartDate)
          ) {
            return true;
          } else {
            return false;
          }
        });
      }      
      if(this.Track){
        let Track = this.Track
        this.session_search_list = this.session_search_list.filter((row) => {
          if (
            row.Track.TrackName.includes(Track.TrackName)            
          ) {
            return true;
          } else {
            return false;
          }
        });
      }
      if (this.sessionName) {
        let sessionName = this.sessionName.trim().toLowerCase();
        this.session_search_list = this.session_search_list.filter((row) => {
          if (
            String(row.Name).toLowerCase().includes(sessionName)            
          ) {
            return true;
          } else {
            return false;
          }
        });
      }
    },
    selectAllAttendees: function() {
        this.SelectedAttendees = [];
        if (this.SelectAllAttendees) {
          this.attendee_search_list.forEach(row => {
              this.SelectedAttendees.push(row);
          })
        }        
    },
    selectAllSessions: function() {
        this.SelectedSessions = [];
        if (this.SelectAllSessions) {
          this.session_search_list.forEach(row => {
              this.SelectedSessions.push(row);
          })
        }        
    },
    selectAllSelectedSessions: function() {
      this.SelectedSessionsOuter = []
      this.SelectedSessions.forEach(row => {
          this.SelectedSessionsOuter.push(row);
      })
    },
    selectAllSelectedAttendees: function() {
      this.SelectedAttendeesOuter = []
      this.SelectedAttendees.forEach(row => {
          this.SelectedAttendeesOuter.push(row);
      })
    },
    deleteAllSelectedSessions: function() {
        this.SelectedSessionsOuter.map(row => {
            let id = row.SessionId
            let index = this.SelectedSessions
              .map((x) => {
                return x.SessionId;
              })
              .indexOf(id);
            this.SelectedSessions.splice(index, 1);
        })
        this.SelectedSessionsOuter = []
    },
    deleteAllSelectedAttendees: function() {
        this.unmap_attendees = this.SelectedAttendeesOuter
        this.SelectedAttendeesOuter.map(row => {
            let id = row.AttendeeId
            let index = this.SelectedAttendees
              .map((x) => {
                return x.AttendeeId;
              })
              .indexOf(id);
            this.SelectedAttendees.splice(index, 1);
        })
        this.SelectedAttendeesOuter = []
    },
    show: function () {
      this.showInside = true 
      this.showInside2 = false 
    },
    show2: function () {
      this.showInside = false 
      this.showInside2 = true 
    },
    hide: function () { 
      console.log('hide')
      this.showInside = false
      this.SelectAllSessions = null
      this.showInside2 = false
      this.SelectAllAttendees = null
    },
    getListData(tab){
      if(tab == 'User')
        {}
      else if(tab == 'Group')
        this.$router.push("/event/groupmapping/");
      else
        this.$router.push("/event/sessionmapping/");
    },
    getSettings() {
      this.$vs.loading();

      this.$store.dispatch("sessionManagement/getSettings").then(res => {
        this.settingsData = res;
        this.popupActive2 = true;
        this.$vs.loading.close();
      });
    },
    saveSettings() {
      this.$vs.loading();
      this.$store
        .dispatch("sessionManagement/saveSettings", {
          settingsData: this.settingsData
        })
        .then(res => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Settings",
            text: res.message
          });
          this.$vs.loading.close();
        });
    },
    addRecord() {
      this.$router.push("/event/session/add").catch(() => {});
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all"
      };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    SetTimeByZoneinList: function(strDateTime)
    {  
        var date = moment.tz(strDateTime, Session_Event_TZ).format('MM/DD/YYYY HH:mm A');
        return date
    },
     SetTimeByZone : function(strDateTime, timeZone)
    {  
        var date = moment.tz(strDateTime, timeZone).format('MM/DD/YYYY HH:mm A');
        return date
    },
  GetTimeByZone : function(strDateTime, timeZone)
    {
      
      strDateTime = moment(strDateTime).format('YYYY-MM-DD HH:mm')
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);      
      return strtDate._d;      
    }, 
    GetDateTimeFromSeconds(seconds) {
      //var myObj = $.parseJSON('{"date_created":\""+seconds.toString()+"\"}');
      var myDate = new Date(1000 * seconds);
      //console.log(myDate.toString());
      //console.log(myDate.toLocaleDateString("en-IN"));
      return myDate.toUTCString();
      //return myDate.toLocaleString();
      //return myDate.toLocaleDateString("en-US");
    },
    addMapping(){
      this.Track = null
      this.SelectedAttendees = []
      this.SelectedSessions = []
      this.unmap_attendees = []
      this.popupActive = true
    },
    editMapping(attendee){
      this.unmap_attendees = []
      if(attendee)
      {
        this.SelectedAttendees = [{
          AttendeeId: attendee.AttendeeId,
          FirstName: attendee.FirstName,
          LastName: attendee.LastName,
          Email: attendee.Email,
          Name: attendee.Name
        }]
        this.$vs.loading();
        this.$store
          .dispatch("agendaManagement/fetchSessionsInAttendee", attendee.AttendeeId)
          .then(res => {  
            this.SelectedSessions = res.map(row =>{ 
              return {
                SessionId: row.SessionId,
                StartDate: row.StartDate,
                EndDate: row.EndDate,
                Track: row.Track,
                Name: row.Name
              }
            })
            this.$vs.loading.close();
            this.popupActive = true
        })
            
          
      }

    },
    getSessions(){
      this.$store
          .dispatch("sessionManagement/fetchSessions")
          .then(res => {  
            this.session_search_list = this.sessionList = res.map(row => {
              return {
                SessionId: row.SessionId,
                StartDate: row.StartDate,
                EndDate: row.EndDate,
                Track: row.Track,
                Name: row.Name
              }
            })    

          })
    },
    getAttendees(){
      this.$store
          .dispatch("attendeeManagement/fetchAttendees")
          .then(res => {              
              this.attendee_search_list = this.attendee_list = res.filter((row) => {
                return row.IsPublished && row.AttendeeId && row.FirstName;
              }).map(row=>{ 
                return {
                  AttendeeId: String(row.AttendeeId)  ,
                  Name: row.Name ? row.Name : null,
                  FirstName: row.FirstName,
                  LastName: row.LastName ? row.LastName : null,
                  Email: row.Email ? row.Email : null
                }
              });
              this.attendee_list = this.attendee_list.sort((a, b) => {
                let fa = a.FirstName.toLowerCase();
                let fb = b.FirstName.toLowerCase();
                if (fa < fb) {
                  return -1;
                }
                if (fa > fb) {
                  return 1;
                }
                return 0;
              });
          })
    },
    getTracks(){
      this.$store
          .dispatch("trackManagement/fetchTracksDropdown")
          .then(res => {  
            this.trackList = res    

          })
    },
    mapSessionAttendee(){
      let SelectedSessions = this.SelectedSessions
      let SelectedAttendees = this.SelectedAttendees
      let unmap_attendees = this.unmap_attendees
      //if(SelectedSessions.length && SelectedAttendees.length)
      //{
        let sessions = SelectedSessions.map(row=>{
          /*row.StartDate = moment.tz(new Date(row.StartDate.seconds * 1000).toUTCString(), Session_Event_TZ).format('DD/MM/YYYY HH:mm A')
          row.EndDate = moment.tz(new Date(row.EndDate.seconds * 1000).toUTCString(), Session_Event_TZ).format('DD/MM/YYYY HH:mm A')*/
          row.StartDate = new Date(row.StartDate.seconds * 1000).toUTCString();
          row.EndDate = new Date(row.EndDate.seconds * 1000).toUTCString();
          return row
        })
        
        this.$vs.loading();
        this.$store.dispatch("agendaManagement/mapSessionAttendee", {
          sessions: sessions,
          attendees: SelectedAttendees,
          unmap_attendees: unmap_attendees,
          mapgroups: [],
          unmapgroups: []
        }).then(res => {  
          if(res.status == 200)
          {
            this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Mapping",
                text: "Data Saved successfully.",
              });


          }
          else
          {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              title: "Mapping",
              text: "Data not Saved!",
            });
          } 
          this.unmap_attendees = []
           this.popupActive = false           
          this.$vs.loading.close();
          location.reload();
          //this.$store.dispatch("attendeeManagement/fetchAttendeesMapping")
        })
      /*}
      else
      {
        this.$vs.dialog({
          type: "alert",
          color: "danger",
          title: "Mapping",
          text: "Session & Attendee should be selected!",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }*/
    }
  },
  mounted() {
    this.gridOptions.api.showLoadingOverlay()
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }

    this.$root.$on("openMappingPopUp", this.editMapping)
  },
  created() {
    if (!moduleSessionManagement.isRegistered) {
      this.$store.registerModule("sessionManagement", moduleSessionManagement);
      moduleSessionManagement.isRegistered = true;
    }    
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule("attendeeManagement", moduleAttendeeManagement);
      moduleAttendeeManagement.isRegistered = true;
    }
    if (!moduleTrackManagement.isRegistered) {
      this.$store.registerModule("trackManagement", moduleTrackManagement);
      moduleTrackManagement.isRegistered = true;
    }
    if (!moduleAgendaManagement.isRegistered) {
      this.$store.registerModule("agendaManagement", moduleAgendaManagement);
      moduleAgendaManagement.isRegistered = true;
    }
    this.$store.dispatch("attendeeManagement/fetchAttendeesMapping")
    this.getSessions();
    this.getAttendees();
    this.getTracks();
  }
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>